export const ComponentName = {
  page: "page",
};

export const RouteApi = {
  createUserLogs: "/UserLogs/Create",
  getUserLogs: "/UserLogs",
};
